<div class="tone-scale" role="img" [attr.aria-label]="ariaLabel()">
  @if (showArrow() && !pointsRight()) {
    <span class="tone-caret tone-caret--left" [style.color]="color()" aria-hidden="true"></span>
  }
  @for (group of groups(); track $index) {
    <div class="seg-group">
      @for (seg of group; track seg.index) {
        <span
          class="seg"
          [class.active]="seg.active"
          [style.background-color]="seg.active ? color() : null"
        ></span>
      }
    </div>
  }
  @if (showArrow() && pointsRight()) {
    <span class="tone-caret tone-caret--right" [style.color]="color()" aria-hidden="true"></span>
  }
</div>
